/*eslint-disable */
const $ = window.jQuery = require('jquery');
import {
  Facebook,
  Twitter,
  Linkedin,
  Pinterest,
  Reddit,
  Telegram,
  WhatsApp,
  Email,
  Google
} from "vue-socialmedia-share";
import {
  mapGetters
} from 'vuex'; 
export default {
  name: 'public-blog-details',
  components: {
    Facebook,
    Twitter,
    Linkedin,
    Pinterest,
    Reddit,
    Telegram,
    WhatsApp,
    Email,
    Google
  },
  props: [],
  data () {
    return {
      singleBlogDetails:{},
      url:'',
      publicBlogListState:{},
      publicBlogListResults:[],
      suggestionBlogId:''
    }
  },
  computed: {
    ...mapGetters([
      'publicSingleBlogDetailsByIdGetters',
      'suggestionBlogListGetters',
    ]),
    getBlogDetailsAgainFun(){
      this.singleBlogDetails = this.$store.getters.publicSingleBlogDetailsByIdGetters.data
      return
    },
    getPubBlogListFun(){
      this.publicBlogListState = this.$store.getters.suggestionBlogListGetters.data
      return
    },
    setInitialPubBlogStates(){
      if(this.publicBlogListState != undefined){
        this.publicBlogListResults = this.publicBlogListState.results
      }
    },
  },
  mounted () {
    this.suggestionBlogId = this.$route.params.pubBlogId
    this.getBlogDetailsAgainFun
    this.url = window.location.href
    this.getPubBlogListFun
    this.setInitialPubBlogStates
  },
  methods: {
    changeSuggestionBlogDetailsFun(blogId){
      this.suggestionBlogId = blogId
      if(blogId != this.$route.params.pubBlogId){
        this.$router.push({ name: 'pubBlogDetail', params: { pubBlogId: blogId } })
        this.blogLoader = true
        this.$store.dispatch('getPublicBlogDetailsByIdAction',{id:blogId}).then((res)=>{
          this.singleBlogDetails = res.data.data
          this.blogLoader = false
        }).catch((err)=>{
          this.blogLoader = false
        })
    
      }
    }
  },
  watch:{
    getBlogDetailsAgainFun(){
      return this.$store.getters.publicSingleBlogDetailsByIdGetters
    },
    getPubBlogListFun(){
      return this.$store.getters.suggestionBlogListGetters
    },
    setInitialPubBlogStates(){
      if(this.publicBlogListState != undefined){
        this.publicBlogListResults = this.publicBlogListState.results
      }
    },
  },
  beforeCreate: function() {
    $('body').addClass('dashboard')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('dashboard')
    next();
  },
}